// extracted by mini-css-extract-plugin
module.exports = {"ComparativoNutricional":"ComparativoNutricional_ComparativoNutricional__3WZtk","Main":"ComparativoNutricional_Main__1GShi","PullLeft":"ComparativoNutricional_PullLeft__61roT"};